import { useCallback } from 'react';

import {
  EmployeeItemInfoData,
  useEmployeeItemInfo,
} from '~/components/GenericList/EmployeeItemInfo';
import { ProposalAgent } from '~/data/proposals';

type UseProcessAgentInfoOutput = {
  getAgentInfo: (agent: ProposalAgent) => EmployeeItemInfoData;
  getAgentInfoByEmployeeId: (employeeId: number) => EmployeeItemInfoData;
  getAgentsInfo: (agents: ProposalAgent[]) => EmployeeItemInfoData[];
  getAgentsInfoByEmployeeIds: (employeeIds: number[]) => EmployeeItemInfoData[];
};

export const useProcessAgentInfo = (): UseProcessAgentInfoOutput => {
  const { getEmployeeItemInfoById, getEmployeeItemInfoByIds } =
    useEmployeeItemInfo();

  const getAgentInfo = useCallback(
    (agent: ProposalAgent): EmployeeItemInfoData =>
      getEmployeeItemInfoById(agent.userId),
    [getEmployeeItemInfoById],
  );

  const getAgentsInfo = useCallback(
    (agents: ProposalAgent[]): EmployeeItemInfoData[] => {
      return agents.map(getAgentInfo);
    },
    [getAgentInfo],
  );

  return {
    getAgentInfo,
    getAgentInfoByEmployeeId: getEmployeeItemInfoById,
    getAgentsInfo,
    getAgentsInfoByEmployeeIds: getEmployeeItemInfoByIds,
  };
};
